<ng-template #buttons>
    <app-button
        icon="pi-print"
        label="workData.printDialog.buttons.print"
        (clickEvent)="printRecords()"
    ></app-button>
</ng-template>

<app-table
    tableKey="workUnrealizedVisits"
    [gridData]="$any(store.data.getWorks())"
    [transformItem]="workHideDelete()"
    [columns]="columns"
    translatePrefix="workData.unrealizedVisits."
    [buttons]="extendedWorkExportsEnabled ? buttons : null"
    [showSearch]="true"
    [showColumnVisiblity]="true"
    [showExport]="true"
    (deleteCallbackWithEvent)="delete($event)"
    [showDelete]="store.isAllowed('work.delete')() && (!folderId || folderStore.canEdit())"
    (detailCallback)="detail($event)"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.getWorks"
    [resource]="'work'"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
>
    @if (extendedWorkExportsEnabled) {
        <ng-template pTemplate="link" let-item="item">
            <app-button
                styleClass="tableIcon"
                svgIcon="pdf"
                [text]="true"
                (clickEvent)="$event.stopPropagation(); printRecord(item)"
            ></app-button>
        </ng-template>
    }
</app-table>
